import React, { Component } from 'react';
import axios from 'axios';
import store from '../../store/index';
import SpinnerLoader from '../../components/common/SpinnerLoader';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import Header from '../../components/admin/common/Header';
import Footer from '../../components/common/Footer';
import { Link } from "react-router-dom";
import arrow_back from '../../assets/icons/arrow-back.svg';
import { Modal, Card, Row, Col } from 'react-bootstrap';

class PlatformFeeSettings extends Component {
    constructor(props) {
        super(props);
        this.authInfo = store.getState().auth.authInfo;
        this.state = {
            loading: false,
            categoryList: [],
            globalSettings: {
                flatFee: 0,
                percentageFee: 0,
                feeType: 'flat',
                isActive: true,
                vatGstEnabled: false,
                vatGstRate: 0,
                vatGstLabel: 'VAT/GST',
                subscriptionTaxEnabled: false,
                subscriptionTaxLabel: 'VAT/GST',
                baseCurrency: '',
                withdrawalProcessingFee: 0,
                fxMarkupEnabled: false,
                fxMarkupDefaultTier: 'Default',
                fxMarkupDefaultPercent: 1,
            },
            selectedRows: [],
            currentCategory: null,
            permissions: {
                add: false,
                edit: false,
                delete: false
            },
            modalShow: false,
            globalSettingsLoading: false,
            currencyOptions: [],
            currenciesLoading: false,
        };

        // For closing bootstrap modal
        this.modalRef = React.createRef();
        this.flatFeeFormRef = React.createRef();
    }

    componentDidMount() {
        this.getPermissions();
        this.fetchGlobalSettings();
        this.fetchActiveCurrencies();
    }

    fetchActiveCurrencies = async () => {
        this.setState({ currenciesLoading: true });
        try {
            const response = await axios.get("/admin/currencies?isActive=true&limit=500", {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${this.authInfo.token}`
                }
            });
            const raw = response.data.data || [];
            const sorted = [...raw].sort((a, b) =>
                String(a.code || '').localeCompare(String(b.code || ''), undefined, { sensitivity: 'base' })
            );
            this.setState({ currencyOptions: sorted });
        } catch (error) {
            console.error("Error fetching currencies:", error);
            this.setState({ currencyOptions: [] });
        } finally {
            this.setState({ currenciesLoading: false });
        }
    };

    getPermissions = async () => {
        const admin_Id = this.authInfo.id;
        try {
            // You might want to create a specific permission for platform fee settings
            const res = await axios.get(`admin/getPlatformFeePermission/${admin_Id}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${this.authInfo.token}`
                }
            });

            if (res.data.status === true && res.data.data) {
                this.setState({ permissions: res.data.data });
            }
        } catch (error) {
            // Default permissions if endpoint doesn't exist yet
            this.setState({
                permissions: { add: true, edit: true, delete: true }
            });
            console.error("Error fetching permissions: ", error);
        }
    }

    fetchGlobalSettings = async () => {
        this.setState({ globalSettingsLoading: true });
        try {
            const response = await axios.get("/admin/platform-settings/global", {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${this.authInfo.token}`
                }
            });

            if (response.data.status === true) {
                this.setState({
                    globalSettings: response.data.data || {
                        flatFee: 0,
                        percentageFee: 0,
                        feeType: 'flat',
                        isActive: true,
                        vatGstEnabled: false,
                        vatGstRate: 0,
                        vatGstLabel: 'VAT/GST',
                        subscriptionTaxEnabled: false,
                subscriptionTaxLabel: 'VAT/GST',
                        baseCurrency: '',
                        withdrawalProcessingFee: 0,
                        fxMarkupEnabled: false,
                        fxMarkupDefaultTier: 'Default',
                        fxMarkupDefaultPercent: 1,
                    }
                });
            }
        } catch (error) {
            console.error("Error fetching global settings:", error);
            // Keep default values if API call fails
        } finally {
            this.setState({ globalSettingsLoading: false });
        }
    };

    updateGlobalSettings = async (values, { setSubmitting }) => {
        try {
            const response = await axios.put("/admin/platform-settings/global", {
                flatFee: parseFloat(values.flatFee),
                percentageFee: parseFloat(values.percentageFee),
                feeType: values.feeType,
                isActive: values.isActive,
                vatGstEnabled: values.vatGstEnabled === true,
                vatGstLabel: (values.vatGstLabel || 'VAT/GST').trim(),
                subscriptionTaxEnabled: values.subscriptionTaxEnabled === true,
                subscriptionTaxLabel: (values.subscriptionTaxLabel || 'VAT/GST').trim(),
                baseCurrency: String(values.baseCurrency || '').trim().toUpperCase(),
                withdrawalProcessingFee: parseFloat(values.withdrawalProcessingFee) || 0,
                fxMarkupEnabled: values.fxMarkupEnabled === true,
                fxMarkupDefaultTier: (values.fxMarkupDefaultTier || 'Default').trim() || 'Default',
                fxMarkupDefaultPercent: parseFloat(values.fxMarkupDefaultPercent) || 0,
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${this.authInfo.token}`
                }
            });

            if (response.data.status === true) {
                toast.success("Global platform fee settings updated successfully");
                this.setState({
                    globalSettings: {
                        flatFee: parseFloat(values.flatFee),
                        percentageFee: parseFloat(values.percentageFee),
                        feeType: values.feeType,
                        isActive: values.isActive,
                        vatGstEnabled: values.vatGstEnabled === true,
                        vatGstLabel: (values.vatGstLabel || 'VAT/GST').trim(),
                        subscriptionTaxEnabled: values.subscriptionTaxEnabled === true,
                subscriptionTaxLabel: (values.subscriptionTaxLabel || 'VAT/GST').trim(),
                        baseCurrency: String(values.baseCurrency || '').trim().toUpperCase(),
                        withdrawalProcessingFee: parseFloat(values.withdrawalProcessingFee) || 0,
                        fxMarkupEnabled: values.fxMarkupEnabled === true,
                        fxMarkupDefaultTier: (values.fxMarkupDefaultTier || 'Default').trim() || 'Default',
                        fxMarkupDefaultPercent: parseFloat(values.fxMarkupDefaultPercent) || 0,
                    }
                });
            } else {
                toast.error(response.data.message || "Failed to update settings");
            }
        } catch (error) {
            console.error("Error updating global settings:", error);
            toast.error("Failed to update global settings");
        } finally {
            setSubmitting(false);
        }
    };

    handleEditCategoryFee = (row) => {
        this.setState({
            currentCategory: {
                ...row,
                editPlatformFee: row.platformFee || 0
            }
        });
    }

    handleRowSelected = (state) => {
        this.setState({ selectedRows: state.selectedRows });
    };

    render() {
        const {
            loading,
            categoryList,
            globalSettings,
            globalSettingsLoading,
            currencyOptions,
            currenciesLoading,
            selectedRows,
            currentCategory,
            permissions
        } = this.state;

        const activeCurrencyCodes = (currencyOptions || [])
            .map((c) => String(c.code || '').trim().toUpperCase())
            .filter(Boolean);
        const savedBase = (globalSettings.baseCurrency && String(globalSettings.baseCurrency).trim().toUpperCase()) || '';
        const orphanSavedBase = Boolean(savedBase && !activeCurrencyCodes.includes(savedBase));

        let baseCurrencySchema = Yup.string()
            .required('Base currency is required')
            .matches(/^[A-Za-z]{3}$/, 'Use a 3-letter ISO code');
        if (activeCurrencyCodes.length > 0) {
            const allowed = orphanSavedBase
                ? [...new Set([...activeCurrencyCodes, savedBase])]
                : activeCurrencyCodes;
            baseCurrencySchema = Yup.string()
                .required('Base currency is required')
                .oneOf(allowed, 'Choose a currency from your active list (Manage Currencies)');
        }

        const globalSettingsValidation = Yup.object({
            feeType: Yup.string()
                .required('Fee type is required')
                .oneOf(['flat', 'percentage'], 'Fee type must be either flat or percentage'),
            flatFee: Yup.number()
                .when('feeType', {
                    is: 'flat',
                    then: (schema) => schema
                        .required('Flat fee is required')
                        .min(0, 'Flat fee must be 0 or greater')
                        .max(1000, 'Flat fee cannot exceed $1000'),
                    otherwise: (schema) => schema.min(0).max(1000)
                }),
            percentageFee: Yup.number()
                .when('feeType', {
                    is: 'percentage',
                    then: (schema) => schema
                        .required('Percentage fee is required')
                        .min(0, 'Percentage fee must be 0 or greater')
                        .max(100, 'Percentage fee cannot exceed 100%'),
                    otherwise: (schema) => schema.min(0).max(100)
                }),
            isActive: Yup.boolean(),
            vatGstEnabled: Yup.boolean(),
            vatGstLabel: Yup.string().max(80, 'Max 80 characters'),
            subscriptionTaxEnabled: Yup.boolean(),
            subscriptionTaxLabel: Yup.string().max(80, 'Max 80 characters'),
            baseCurrency: baseCurrencySchema,
            withdrawalProcessingFee: Yup.number()
                .typeError('Enter a number')
                .min(0, 'Must be 0 or greater')
                .max(1000, 'Cannot exceed 1000'),
            fxMarkupEnabled: Yup.boolean(),
            fxMarkupDefaultTier: Yup.string().max(60, 'Max 60 characters'),
            fxMarkupDefaultPercent: Yup.number()
                .typeError('Enter a number')
                .min(0, 'Min 0')
                .max(100, 'Max 100'),
        });

        return (
            <React.Fragment>
                {globalSettingsLoading === true ? <SpinnerLoader /> : ""}
                <div className="seller_body">
                    <Header />
                    <Helmet>
                        <title>{"Admin - Platform fees & currency - Pay Earth"}</title>
                    </Helmet>
                    <div className="inr_top_page_title">
                        <h2 className="mb-0">Platform fees &amp; currency</h2>
                    </div>
                    <div className="seller_dash_wrap pt-2 pb-5">
                        <div className="container">

                        <Row className="mb-4 g-4">
                            <Col md={8} className="order-2 order-md-1">
                                <Card className="shadow-sm border-0 h-100">
                                    <Card.Body className="p-3 p-md-4">
                                        {(
                                            <Formik
                                                ref={this.flatFeeFormRef}
                                                enableReinitialize={true}
                                                initialValues={{
                                                    flatFee: globalSettings.flatFee || 0,
                                                    percentageFee: globalSettings.percentageFee || 0,
                                                    feeType: globalSettings.feeType || 'flat',
                                                    isActive: globalSettings.isActive !== false,
                                                    vatGstEnabled: globalSettings.vatGstEnabled === true || globalSettings.vatGstEnabled === 'true',
                                                    vatGstLabel: globalSettings.vatGstLabel || 'VAT/GST',
                                                    subscriptionTaxEnabled: globalSettings.subscriptionTaxEnabled === true || globalSettings.subscriptionTaxEnabled === 'true',
                                                    subscriptionTaxLabel: globalSettings.subscriptionTaxLabel || 'VAT/GST',
                                                    baseCurrency: (globalSettings.baseCurrency && String(globalSettings.baseCurrency).trim())
                                                        ? String(globalSettings.baseCurrency).trim().toUpperCase()
                                                        : '',
                                                    withdrawalProcessingFee: globalSettings.withdrawalProcessingFee ?? 0,
                                                    fxMarkupEnabled: globalSettings.fxMarkupEnabled === true || globalSettings.fxMarkupEnabled === 'true',
                                                    fxMarkupDefaultTier: globalSettings.fxMarkupDefaultTier || 'Default',
                                                    fxMarkupDefaultPercent: globalSettings.fxMarkupDefaultPercent ?? 1,
                                                }}
                                                validationSchema={globalSettingsValidation}
                                                onSubmit={this.updateGlobalSettings}
                                            >
                                                {({ isSubmitting, values }) => (
                                                    <Form>
                                                        <p className="text-secondary small mb-4 lh-base">
                                                            Configure platform-wide fees and tax labels. Tax <strong>rates</strong> come from Stripe Tax and per-category tax codes — not manual percentages on this page.
                                                        </p>

                                                        <section className="rounded-3 border bg-white p-3 p-md-4 mb-4 shadow-sm">
                                                            <h3 className="h5 fw-semibold text-dark mb-3 pb-2 border-bottom">Base currency</h3>
                                                            <Row className="g-2 align-items-end">
                                                                <Col sm={10} md={8}>
                                                                    <label htmlFor="baseCurrencyTop" className="form-label">Currency</label>
                                                                    {currenciesLoading ? (
                                                                        <div className="form-control text-muted" style={{ minHeight: '38px' }}>Loading currencies…</div>
                                                                    ) : activeCurrencyCodes.length === 0 ? (
                                                                        <>
                                                                            <Field className="form-control text-uppercase" type="text" name="baseCurrency" maxLength={3} placeholder="e.g. AUD" disabled={!permissions.edit} />
                                                                            <div className="alert alert-warning py-2 px-3 mt-2 mb-0 small">
                                                                                Add currencies under <Link to="/admin/manage-currencies">Manage Currencies</Link>.
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <Field as="select" name="baseCurrency" id="baseCurrencyTop" className="form-select" disabled={!permissions.edit}>
                                                                            <option value="">Select currency</option>
                                                                            {orphanSavedBase && <option value={savedBase}>{savedBase} — saved</option>}
                                                                            {(currencyOptions || []).map((c) => {
                                                                                const code = String(c.code || '').trim().toUpperCase();
                                                                                if (!code) return null;
                                                                                return <option key={c._id || code} value={code}>{code}{c.name ? ` — ${c.name}` : ''}</option>;
                                                                            })}
                                                                        </Field>
                                                                    )}
                                                                    <ErrorMessage name="baseCurrency" component="div" className="text-danger small mt-1" />
                                                                    <div className="small text-secondary mt-2">Used for Wise withdrawals and payout conversion.</div>
                                                                </Col>
                                                            </Row>
                                                        </section>

                                                        <section className="rounded-3 border bg-white p-3 p-md-4 mb-4 shadow-sm">
                                                            <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                                                                <h3 className="h5 fw-semibold text-dark mb-0">Platform fee</h3>
                                                                <div className="form-check form-switch mb-0 ps-0 d-flex align-items-center gap-2">
                                                                    <label className="form-check-label small text-muted mb-0" htmlFor="feeActive">
                                                                        {values.isActive ? 'On' : 'Off'}
                                                                    </label>
                                                                    <Field
                                                                        className="form-check-input ms-0 mt-0"
                                                                        type="checkbox"
                                                                        name="isActive"
                                                                        id="feeActive"
                                                                        role="switch"
                                                                        style={{ width: '2.5em', height: '1.4em', cursor: 'pointer' }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {values.isActive && (
                                                                <Row className="g-3 align-items-end">
                                                                    <Col md={12}>
                                                                        <label className="form-label mb-2">Charge type</label>
                                                                        <div className="d-flex flex-wrap align-items-center column-gap-4 row-gap-2">
                                                                            <div className="form-check d-flex align-items-center gap-2 ps-0 mb-0">
                                                                                <Field
                                                                                    className="form-check-input flex-shrink-0 ms-0 mt-0 float-none"
                                                                                    type="radio"
                                                                                    name="feeType"
                                                                                    value="flat"
                                                                                    id="feeTypeFlat"
                                                                                />
                                                                                <label className="form-check-label mb-0" htmlFor="feeTypeFlat">
                                                                                    Fixed amount
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check d-flex align-items-center gap-2 ps-0 mb-0">
                                                                                <Field
                                                                                    className="form-check-input flex-shrink-0 ms-0 mt-0 float-none"
                                                                                    type="radio"
                                                                                    name="feeType"
                                                                                    value="percentage"
                                                                                    id="feeTypePercentage"
                                                                                />
                                                                                <label className="form-check-label mb-0" htmlFor="feeTypePercentage">
                                                                                    Percent of sale
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        <ErrorMessage name="feeType" component="div" className="text-danger small mt-1" />
                                                                    </Col>
                                                                    {values.feeType === 'flat' && (
                                                                        <Col sm={6} md={5}>
                                                                            <label htmlFor="flatFee" className="form-label">Fixed fee amount</label>
                                                                            <Field
                                                                                className="form-control"
                                                                                type="number"
                                                                                name="flatFee"
                                                                                step="0.01"
                                                                                min="0"
                                                                                max="1000"
                                                                            />
                                                                            <ErrorMessage name="flatFee" component="div" className="text-danger small" />
                                                                        </Col>
                                                                    )}
                                                                    {values.feeType === 'percentage' && (
                                                                        <Col sm={6} md={5}>
                                                                            <label htmlFor="percentageFee" className="form-label">Percent (%)</label>
                                                                            <Field
                                                                                className="form-control"
                                                                                type="number"
                                                                                name="percentageFee"
                                                                                step="0.01"
                                                                                min="0"
                                                                                max="100"
                                                                            />
                                                                            <ErrorMessage name="percentageFee" component="div" className="text-danger small" />
                                                                        </Col>
                                                                    )}
                                                                </Row>
                                                            )}
                                                        </section>

                                                        <section className="rounded-3 border bg-white p-3 p-md-4 mb-4 shadow-sm">
                                                            <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                                                                <h3 className="h5 fw-semibold text-dark mb-0">
                                                                    Marketplace tax (Stripe)
                                                                </h3>
                                                                <div className="form-check form-switch mb-0 ps-0 d-flex align-items-center gap-2">
                                                                    <label className="form-check-label small text-muted mb-0" htmlFor="vatGstEnabled">
                                                                        {values.vatGstEnabled ? 'On' : 'Off'}
                                                                    </label>
                                                                    <Field
                                                                        className="form-check-input ms-0 mt-0"
                                                                        type="checkbox"
                                                                        name="vatGstEnabled"
                                                                        id="vatGstEnabled"
                                                                        role="switch"
                                                                        style={{ width: '2.5em', height: '1.4em', cursor: 'pointer' }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {values.vatGstEnabled ? (
                                                                <Row className="g-3">
                                                                    <Col sm={8} md={6}>
                                                                        <label htmlFor="vatGstLabel" className="form-label">Customer-facing label</label>
                                                                        <Field
                                                                            className="form-control"
                                                                            type="text"
                                                                            name="vatGstLabel"
                                                                            placeholder="e.g. GST"
                                                                        />
                                                                        <ErrorMessage name="vatGstLabel" component="div" className="text-danger small" />
                                                                    </Col>
                                                                    <Col xs={12}>
                                                                        <div className="small text-secondary">
                                                                            Rates are calculated by Stripe from each category&apos;s tax code. Set codes under{' '}
                                                                            <Link to="/admin/manage-product-categories">product</Link> and{' '}
                                                                            <Link to="/admin/manage-service-categories">service</Link> categories.
                                                                        </div>
                                                                        <div className="alert alert-warning small mt-3 mb-0 py-2">
                                                                            Activate Stripe Tax in your Stripe Dashboard (Test or Live — must match your API keys)
                                                                            and add registrations for buyer countries. Buyers never see setup errors; sellers
                                                                            who are not tax-ready rely on platform collection.{' '}
                                                                            <a
                                                                                href="https://dashboard.stripe.com/test/tax"
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                Open Stripe Tax (Test) →
                                                                            </a>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            ) : (
                                                                <p className="small text-secondary mb-0">When off, marketplace checkout does not add Stripe Tax.</p>
                                                            )}
                                                        </section>

                                                        <section className="rounded-3 border bg-white p-3 p-md-4 mb-4 shadow-sm">
                                                            <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                                                                <h3 className="h5 fw-semibold text-dark mb-0">Subscription &amp; advertising tax</h3>
                                                                <div className="form-check form-switch mb-0 ps-0 d-flex align-items-center gap-2">
                                                                    <label className="form-check-label small text-muted mb-0" htmlFor="subscriptionTaxEnabled">
                                                                        {values.subscriptionTaxEnabled ? 'On' : 'Off'}
                                                                    </label>
                                                                    <Field
                                                                        className="form-check-input ms-0 mt-0"
                                                                        type="checkbox"
                                                                        name="subscriptionTaxEnabled"
                                                                        id="subscriptionTaxEnabled"
                                                                        role="switch"
                                                                        style={{ width: '2.5em', height: '1.4em', cursor: 'pointer' }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {values.subscriptionTaxEnabled ? (
                                                                <Row className="g-3">
                                                                    <Col sm={8} md={6}>
                                                                        <label htmlFor="subscriptionTaxLabel" className="form-label">Customer-facing label</label>
                                                                        <Field className="form-control" type="text" name="subscriptionTaxLabel" placeholder="e.g. VAT" />
                                                                        <ErrorMessage name="subscriptionTaxLabel" component="div" className="text-danger small" />
                                                                    </Col>
                                                                    <Col xs={12}>
                                                                        <div className="small text-secondary">
                                                                            Platform-collected tax on subscriptions and ads. Stripe calculates the rate; only the label is configured here.
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            ) : (
                                                                <p className="small text-secondary mb-0">When off, subscription and advertising charges exclude automatic tax.</p>
                                                            )}
                                                        </section>

                                                        <section className="rounded-3 border bg-white p-3 p-md-4 mb-4 shadow-sm">
                                                            <h3 className="h5 fw-semibold text-dark mb-3 pb-2 border-bottom">
                                                                Seller withdrawal
                                                            </h3>
                                                            <Row className="g-3 align-items-end">
                                                                <Col sm={6} md={5}>
                                                                    <label htmlFor="withdrawalProcessingFee" className="form-label">
                                                                        Processing fee{values.baseCurrency ? ` (${values.baseCurrency})` : ''}
                                                                    </label>
                                                                    <Field
                                                                        className="form-control"
                                                                        type="number"
                                                                        name="withdrawalProcessingFee"
                                                                        id="withdrawalProcessingFee"
                                                                        step="0.01"
                                                                        min="0"
                                                                        max="1000"
                                                                    />
                                                                    <ErrorMessage name="withdrawalProcessingFee" component="div" className="text-danger small" />
                                                                    <div className="small text-secondary mt-2">
                                                                        Flat fee deducted from each seller withdrawal, charged in the base currency and converted to the payout currency at the displayed rate.
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </section>

                                                        <section className="rounded-3 border bg-white p-3 p-md-4 mb-4 shadow-sm">
                                                            <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                                                                <h3 className="h5 fw-semibold text-dark mb-0">
                                                                    FX markup
                                                                </h3>
                                                                <div className="form-check form-switch mb-0 ps-0 d-flex align-items-center gap-2">
                                                                    <label className="form-check-label small text-muted mb-0" htmlFor="fxMarkupEnabled">
                                                                        {values.fxMarkupEnabled ? 'On' : 'Off'}
                                                                    </label>
                                                                    <Field
                                                                        className="form-check-input ms-0 mt-0"
                                                                        type="checkbox"
                                                                        name="fxMarkupEnabled"
                                                                        id="fxMarkupEnabled"
                                                                        role="switch"
                                                                        style={{ width: '2.5em', height: '1.4em', cursor: 'pointer' }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {values.fxMarkupEnabled && (
                                                                <Row className="g-3 align-items-end">
                                                                    <Col sm={4} md={3}>
                                                                        <label htmlFor="fxMarkupDefaultPercent" className="form-label">Default tier markup (%)</label>
                                                                        <Field
                                                                            className="form-control"
                                                                            type="number"
                                                                            name="fxMarkupDefaultPercent"
                                                                            id="fxMarkupDefaultPercent"
                                                                            step="0.01"
                                                                            min="0"
                                                                            max="100"
                                                                        />
                                                                        <ErrorMessage name="fxMarkupDefaultPercent" component="div" className="text-danger small" />
                                                                    </Col>
                                                                    <Col sm={8} md={6}>
                                                                        <label htmlFor="fxMarkupDefaultTier" className="form-label">Default tier name</label>
                                                                        <Field
                                                                            className="form-control"
                                                                            type="text"
                                                                            name="fxMarkupDefaultTier"
                                                                            id="fxMarkupDefaultTier"
                                                                            placeholder="Default"
                                                                        />
                                                                        <ErrorMessage name="fxMarkupDefaultTier" component="div" className="text-danger small" />
                                                                    </Col>
                                                                    <Col xs={12}>
                                                                        <div className="small text-secondary">
                                                                            Sellers without a specific tier (<code>fxMarkupTier</code>) get this percent quietly subtracted from the live Wise rate. Multi-tier configuration lives in the <code>fx_markup_tiers</code> setting; when empty, this default percent is used.
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                        </section>

                                                        <div className="d-flex justify-content-end pt-2">
                                                            <button
                                                                type="submit"
                                                                className="btn custom_btn btn_yellow"
                                                                disabled={isSubmitting || !permissions.edit}
                                                            >
                                                                {isSubmitting ? "Saving…" : "Save changes"}
                                                            </button>
                                                        </div>
                                                    </Form>
                                                )}
                                            </Formik>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={4} className="order-1 order-md-2">
                                <Card className="shadow border-0 sticky-md-top" style={{ top: '1rem' }}>
                                    <Card.Header className="bg-dark text-white py-3 px-3 px-md-4">
                                        <h3 className="h4 fw-bold mb-1">Saved values</h3>
                                        <p className="mb-0 small opacity-90 fw-normal lh-sm">
                                            Current saved configuration. Use <strong className="text-white">Save changes</strong> in the form to update.
                                        </p>
                                    </Card.Header>
                                    <Card.Body className="p-3 p-md-4">
                                        <dl className="row mb-0 gy-3">
                                            <dt className="col-5 text-secondary fw-normal mb-0 align-self-center">Base currency</dt>
                                            <dd className="col-7 mb-0 text-end">
                                                <span className="fs-5 fw-bold font-monospace text-dark">
                                                    {(globalSettings.baseCurrency || '—').toString().toUpperCase()}
                                                </span>
                                            </dd>
                                            <dt className="col-5 text-secondary fw-normal mb-0 align-self-center">Platform fee</dt>
                                            <dd className="col-7 mb-0 text-end fs-6">
                                                {globalSettings.feeType === 'flat'
                                                    ? <>Fixed · <strong className="text-dark">{globalSettings.flatFee ?? 0}</strong></>
                                                    : <><strong className="text-dark">{globalSettings.percentageFee ?? 0}%</strong> of sale</>}
                                            </dd>
                                            <dt className="col-5 text-secondary fw-normal mb-0 align-self-center">Fee active</dt>
                                            <dd className="col-7 mb-0 text-end">
                                                <span className={`badge rounded-pill px-3 py-2 fs-6 ${globalSettings.isActive ? 'bg-success' : 'bg-secondary'}`}>
                                                    {globalSettings.isActive ? 'Yes' : 'No'}
                                                </span>
                                            </dd>
                                            <dt className="col-5 text-secondary fw-normal mb-0 align-self-center">Marketplace tax</dt>
                                            <dd className="col-7 mb-0 text-end fs-6">
                                                {globalSettings.vatGstEnabled ? (
                                                    <div>
                                                        <span className="badge bg-primary rounded-pill px-3 py-2">On</span>
                                                        <div className="mt-2 small text-secondary">
                                                            Stripe · <span className="text-dark fw-medium">{globalSettings.vatGstLabel || 'VAT/GST'}</span>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <span className="badge bg-secondary rounded-pill px-3 py-2 fs-6">Off</span>
                                                )}
                                            </dd>
                                            <dt className="col-5 text-secondary fw-normal mb-0 align-self-center">Subscription tax</dt>
                                            <dd className="col-7 mb-0 text-end fs-6">
                                                {globalSettings.subscriptionTaxEnabled ? (
                                                    <div>
                                                        <span className="badge bg-primary rounded-pill px-3 py-2">On</span>
                                                        <div className="mt-2 small text-secondary">
                                                            <span className="text-dark fw-medium">{globalSettings.subscriptionTaxLabel || 'VAT/GST'}</span>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <span className="badge bg-secondary rounded-pill px-3 py-2">Off</span>
                                                )}
                                            </dd>
                                            <dt className="col-5 text-secondary fw-normal mb-0 align-self-center">Withdrawal fee</dt>
                                            <dd className="col-7 mb-0 text-end fs-6">
                                                {Number(globalSettings.withdrawalProcessingFee) > 0 ? (
                                                    <strong className="text-dark">
                                                        {Number(globalSettings.withdrawalProcessingFee).toFixed(2)}
                                                        {globalSettings.baseCurrency ? ` ${String(globalSettings.baseCurrency).toUpperCase()}` : ''}
                                                    </strong>
                                                ) : (
                                                    <span className="badge bg-secondary rounded-pill px-3 py-2 fs-6">None</span>
                                                )}
                                            </dd>
                                            <dt className="col-5 text-secondary fw-normal mb-0 align-self-center">FX markup</dt>
                                            <dd className="col-7 mb-0 text-end fs-6">
                                                {globalSettings.fxMarkupEnabled ? (
                                                    <div>
                                                        <span className="badge bg-primary rounded-pill px-3 py-2">On</span>
                                                        <div className="mt-2 small text-secondary">
                                                            <strong className="text-dark">{Number(globalSettings.fxMarkupDefaultPercent ?? 0).toFixed(2)}%</strong>
                                                            {' · '}
                                                            <span className="text-dark fw-medium">{globalSettings.fxMarkupDefaultTier || 'Default'}</span>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <span className="badge bg-secondary rounded-pill px-3 py-2 fs-6">Off</span>
                                                )}
                                            </dd>
                                        </dl>

                                        <hr className="my-4 text-secondary opacity-25" />

                                        <p className="small text-secondary mb-0 lh-base">
                                            <strong className="text-dark">Saved values</strong> is what the platform uses now.
                                            Use <strong className="text-dark">Save changes</strong> to update.
                                            Base currency drives Wise withdrawals and Stripe payouts—add codes in{' '}
                                            <Link to="/admin/manage-currencies">Manage Currencies</Link> if needed.
                                        </p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>


                        </div>
                    </div>
                    <Footer />
                </div>
            </React.Fragment>
        );
    }
}

export default PlatformFeeSettings;
